export default class GoogleTagManagerService {
  static loadGTM(gtmId: string): void {
    if (document.getElementById("gtm-script")) {
      return;
    }

    const script = document.createElement("script");
    script.id = "gtm-script";
    script.src = `https://www.googletagmanager.com/gtm.js?id=${gtmId}`;
    script.async = true;
    script.onload = () => {
      console.log(`Google Tag Manager ${gtmId} carregado com sucesso.`);
    };

    const head = document.getElementsByTagName("head")[0];
    head.appendChild(script);
  }

  static pushDataLayer(data: object): void {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(data);
  }
}
